// firebase.js
import {initializeApp} from "firebase/app";
import {getFirestore} from 'firebase/firestore'; // Import Firestore
import {getAuth } from 'firebase/auth'; // Import Firebase authentication module
import {getStorage} from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBKgXAHejXOppGDI3ob1DF5BPbqRO_4CDE",
  authDomain: "auth.aidify.ca",
  projectId: "aidify-5eead",
  storageBucket: "aidify-5eead.firebasestorage.app",
  messagingSenderId: "443533569456",
  appId: "1:443533569456:web:df07a4cc455d28e908fa75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); // Initialize Firebase authentication
export const db = getFirestore(app); // Initialize Firestore database
export const storage = getStorage(app);
// Export Google provider for authentication
// export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
// export { auth }; // Export other authentication methods if needed
